package com.starparty.app.astro0

import com.starparty.app.astro0.celestialobjects.Star

/**
 * Title:
 * Description:
 * Copyright:    Copyright (c) 2002
 * Company:
 * @author
 * @version 1.0
 */
class UMSStar(
        time: SP_Time,
        ra: UMS,
        dec: UMS,
        constellationNumber: Int,
        bayerDesignation: String,
        flamsteadNumber: String,
        visualMagnitude: Double,
        bv: Double,
        spectralType: String,
        name: String
) : Star(
    time,
    UMS.hourMinSecToDecimalDegrees(ra.toString()),
    UMS.unitMinSecToDecimal(dec),
    constellationNumber,
    bayerDesignation,
    flamsteadNumber,
    visualMagnitude,
    bv,
    spectralType,
    name
) {
    var rA_HMS = UMS()
        protected set
    var dec_DMS = UMS()
        protected set

    init {
        rA_HMS = ra
        dec_DMS = dec
    }
}